import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || "/api";

const api = axios.create({
    baseURL: API_URL,
});

// Request interceptor to add auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor for error handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Auth API
export const authApi = {
    register: (data) => api.post('/auth/register', data),
    login: (data) => api.post('/auth/login', data),
    getMe: () => api.get('/auth/me'),
};

// Settings API
export const settingsApi = {
    get: () => api.get('/settings'),
    update: (data) => api.put('/settings', data),
    previewQuote: (settings) => api.post('/pdf/quote/preview', { settings }, { responseType: 'blob' }),
    uploadLogo: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return api.post('/settings/logo', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
};

// Products API
export const productsApi = {
    getAll: () => api.get('/products'),
    create: (data) => api.post('/products', data),
    update: (id, data) => api.put(`/products/${id}`, data),
    delete: (id) => api.delete(`/products/${id}`),
};

// Quotes API
export const quotesApi = {
    getAll: () => api.get('/quotes'),
    getOne: (id) => api.get(`/quotes/${id}`),
    create: (data) => api.post('/quotes', data),
    update: (id, data) => api.put(`/quotes/${id}`, data),
    delete: (id) => api.delete(`/quotes/${id}`),
    getPdf: (id) => api.get(`/pdf/quote/${id}`, { responseType: 'blob' }),
};

// Invoices API
export const invoicesApi = {
    getAll: () => api.get('/invoices'),
    create: (data) => api.post('/invoices', data),
    delete: (id) => api.delete(`/invoices/${id}`),
    updateStatus: (id, status) => api.put(`/invoices/${id}/status?status=${status}`),
    getPdf: (id) => api.get(`/pdf/invoice/${id}`, { responseType: 'blob' }),
};

// Dashboard API
export const dashboardApi = {
    getStats: () => api.get('/dashboard/stats'),
};

export default api;
